export class SignType {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const SignTypesChoices = {
  INPRESS: new SignType('IP', 0),
  STICKER: new SignType('Kleefbord', 1)
};

export const SignTypesChoiceArray = Object.values(SignTypesChoices);
